import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserUnfilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M12.095 10.484a4.5 4.5 0 1 0-4.191-.001c-1.691.393-2.99 1.247-3.913 2.263-1.245 1.37-1.83 3.067-1.73 4.314a.75.75 0 1 0 1.495-.12c-.06-.753.32-2.057 1.346-3.186.997-1.097 2.586-2.004 4.902-2.004 2.31 0 3.816.901 4.774 1.994.98 1.12 1.406 2.463 1.474 3.316a.75.75 0 1 0 1.496-.12c-.093-1.147-.632-2.803-1.842-4.184-.894-1.02-2.143-1.877-3.812-2.272ZM13 6.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUserUnfilled;
